import { useState, useEffect } from 'react'
import { consentCookieHelper } from '../utils'
import useInterval from './useInterval'

const useCookieConsent = (category: string): boolean => {
  const [hasConsent, setHasConsent] = useState(null)

  const setCookieConsent = () => {
    const cookies = global.document.cookie

    const consentCookieValue = consentCookieHelper.getConsentCookieValue(cookies)
    if (consentCookieValue === '') {
      return setHasConsent(null)
    }

    // Set opted out in case invalid cookie value or invalid category passed in
    if (!consentCookieValue.includes('consent:') || !consentCookieHelper.categories[category]) {
      return setHasConsent(false)
    }

    const categorySection = consentCookieHelper.getCategorySection(consentCookieValue, category)

    // If can't find section, then all cookies were accepted (example value: 'ts:1575020721807|consent:true')
    if (!categorySection.length && consentCookieValue.includes('consent:true')) {
      return setHasConsent(true)
    }

    return setHasConsent(consentCookieHelper.hasOptedIn(categorySection[0]))
  }

  // Get cookie on mount
  useEffect(() => {
    setCookieConsent()
  }, [])

  // Check for cookie value every second if no value
  useInterval(
    () => {
      setCookieConsent()
    },
    1000,
    hasConsent !== null
  )

  return hasConsent
}

export default useCookieConsent
